import { Encodable } from "../Encodable";
import { ConcreteEncodable } from "./ConcreteEncodable";

import { OrderDataImplEncoder } from "../../encoder/OrderDataImplEncoder";

import * as CubiqTS from "../../index";
import { OrderData } from "../OrderData";

export class OrderDataImpl extends ConcreteEncodable implements OrderData {
  public static enType: string = "com.bcdfx.model.event.lifecycle.fx.OrderDataImpl";
  public isPrivate: boolean;
  public fixingDate: CubiqTS.moment.Moment | null = null;
  public rateSourceCd: string;
  public vwapAllInRt: CubiqTS.BigNumber | null = null;
  public swapDetails: CubiqTS.SwapDetails;
  public lastFillDetails: CubiqTS.LastFillDetails;
  public siblingRelationship: CubiqTS.Relationship;
  public settleTenor: CubiqTS.Tenor;
  public adjustedSettleTenor: CubiqTS.Tenor;
  public isInvertedOrderFg: boolean;
  public orderErrors: CubiqTS.Errors;
  public suspensionDetails: CubiqTS.SuspensionDetails;
  public expiryAlias: string;
  public isOddFixingDateFg: boolean;
  public trailingStopDetails: CubiqTS.TrailingStopDetails;
  public triggerDetails: CubiqTS.TriggerDetails;
  public leavesSettleQty: CubiqTS.BigNumber | null = null;
  public parentRelationship: CubiqTS.Relationship;
  public usdEquivLeavesQty: CubiqTS.BigNumber | null = null;
  public executedQty: CubiqTS.BigNumber | null = null;
  public executedSettleQty: CubiqTS.BigNumber | null = null;
  public usdEquivExecutedQty: CubiqTS.BigNumber | null = null;
  public creditRevalDetails: CubiqTS.CreditRevalDetails;
  public forwardDetails: CubiqTS.ForwardDetails;
  public strategyParameters: Array<CubiqTS.StrategyParameterImpl>;
  public algoStrategyName: string;
  public targetDeskId: CubiqTS.Long | null = null;
  public gammaRungId: CubiqTS.Long | null = null;
  public clOrdLinkID: string;
  public requestTrackingType: CubiqTS.RequestTrackingType;
  public fixingSourceCd: string;
  public trackingSide: CubiqTS.RateSideType;
  public monitoringOrderType: CubiqTS.OrderType;
  public executionType: CubiqTS.ExecutionType;
  public requestedOrderType: CubiqTS.RequestOrderType;
  public clientTraderName: string;
  public activationAlias: string;
  public activationDts: CubiqTS.moment.Moment | null = null;
  public childRelationships: Array<CubiqTS.Relationship>;
  public executionInstruction: CubiqTS.FillSupport;
  public isRateReverseEngineeringFg: boolean;
  public isAutoEligible: boolean;
  public nonBaseCode: string;
  public clientIntent: CubiqTS.OrderIntent;
  public orderId: CubiqTS.Long | null = null;
  public orderRef: string;
  public orderRevisionId: CubiqTS.Long | null = null;
  public clientCode: string;
  public clientName: string;
  public clientSegment: string;
  public clientIsTraderVisible: boolean;
  public clientStraightThroughProcessing: boolean;
  public orderType: CubiqTS.OrderType;
  public product: CubiqTS.Product;
  public comments1: string;
  public orderQty: CubiqTS.BigNumber | null = null;
  public expiryDts: CubiqTS.moment.Moment | null = null;
  public trackingRt: CubiqTS.BigNumber | null = null;
  public channelCd: string;
  public isModifiable: boolean;
  public stpHold: boolean;
  public clOrdID: string;
  public vwapSpotRt: CubiqTS.BigNumber | null = null;
  public comments2: string;
  public expiryType: CubiqTS.OrderExpiryType;
  public deskId: CubiqTS.Long | null = null;
  public slippage: string;
  public settleQty: CubiqTS.BigNumber | null = null;
  public leavesQty: CubiqTS.BigNumber | null = null;
  public baseCode: string;
  public fixedCode: string;
  public strategyId: CubiqTS.Long | null = null;
  public strategyRef: string;
  public strategyType: CubiqTS.StrategyType | null = null;
  public orderState: CubiqTS.OrderState;
  public requestRt: CubiqTS.BigNumber | null = null;
  public entryDts: CubiqTS.moment.Moment | null = null;
  public fillState: CubiqTS.FillState;
  public settleDate: CubiqTS.moment.Moment | null = null;
  public txTime: CubiqTS.moment.Moment | null = null;
  public modifyDts: CubiqTS.moment.Moment | null = null;
  public clientBranchCode: string;
  public entryUserCode: string;
  public accountCode: string;
  public accountName: string;
  public reqMargin: CubiqTS.BigNumber | null = null;
  public reqMarginType: CubiqTS.MarkUpType;
  public salesMargin: CubiqTS.BigNumber | null = null;
  public salesGroupId: CubiqTS.Long | null = null;
  public transferUserId: CubiqTS.Long | null = null;
  public entryUserId: CubiqTS.Long | null = null;
  public lockUserId: CubiqTS.Long | null = null;
  public lockType: CubiqTS.LockType;
  public usdEquivQty: CubiqTS.BigNumber | null = null;
  public messageId: string;
  public isAboutToActivate: boolean;
  public isAboutToExpire: boolean;
  public isAboutToSuspend: boolean;
  public isActivatingOrder: boolean;
  public cancelUserId: CubiqTS.Long | null = null;
  public cancelDts: CubiqTS.moment.Moment | null = null;
  public clientContactIds: Array<CubiqTS.Long>;
  public activationDetails: CubiqTS.ActivationDetailsImpl;
  public expiryDetails: CubiqTS.ExpiryDetailsImpl;
  public counterPartyDetails: CubiqTS.CounterPartyDetailsImpl;
  public spotMarkupValue: CubiqTS.BigNumber | null = null;
  public spotMarkupType: CubiqTS.MarkUpType;
  public fwdMarkupValue: CubiqTS.BigNumber | null = null;
  public fwdMarkupType: CubiqTS.MarkUpType;
  public tradesCount: CubiqTS.Long | null = null;
  public clientTraderId: CubiqTS.Long | null = null;
  public lastOwnerGroupId: CubiqTS.Long | null = null;
  public lastOwnerGroupIds: Array<CubiqTS.Long>;
  public ownerGroupIds: Array<CubiqTS.Long>;
  public currencyPairIds: Array<string>;
  public siLockUserId: CubiqTS.Long | null = null;
  public isLoopActiveLeg: boolean;
  public pauseState: CubiqTS.PauseState;
  public allocationData: Array<CubiqTS.AllocationDataImpl>;
  public fixingDetails: CubiqTS.FixingDataImpl;
  public filledBaseAmt: CubiqTS.BigNumber | null = null;
  public currencyPairAndOwners: Array<CubiqTS.BenchmarkVisibilityPairAndOwnerImpl>;
  public algoProfileId: string;
  public passthroughParameters: Array<CubiqTS.StrategyParameterImpl>;
  public stpAggregationEnabled: boolean;
  public alternateAccountCode: string;
  public modifyInAcceptanceFg: boolean;

  public detFillMarketRate: CubiqTS.BigNumber | null = null;
  public detFillFwdPoints: CubiqTS.BigNumber | null = null;
  public detFillNdfHorizonPts: CubiqTS.BigNumber | null = null;
  public detFillTradeableFg: boolean;
  public detFillHorizonPtsTradeableFg: boolean;
  public inflightInclusionState: CubiqTS.InflightInclusionState;

  public creditRejectCd: CubiqTS.Long | null;
  public oboClient: string;
  public oboAccount: string;

  public oboEntryUser: string;
  public oboLockUser: string;
  public oboCancelUser: string;
  public modifyUsers: Array<string>;

  public insidePrevisibilityFg: boolean;

  public customValues: Array<CubiqTS.CustomValueImpl>;

  public inboxReason: CubiqTS.Errors;
  public inboxOpsId: CubiqTS.Long;

  public nettingId: string;
  public fwdNettingId: string;
  public autoForwardPricingFg: boolean;
  public hedgingMode: CubiqTS.HedgingModeType;
  public reqQuoteId: string;
  public fillNowOrderAmt: CubiqTS.BigNumber | null = null;
  public marketVwapSpotRt: CubiqTS.BigNumber | null = null;
  public marketVwapAllInRt: CubiqTS.BigNumber | null = null;

  public previousFixingDts: CubiqTS.moment.Moment | null = null;
  public previousTraderVisibilityOffset: CubiqTS.Long | null = null;

  public clientBranchCd: string;
  public clientCd: string;
  public baseCurrencyCd: string;
  public nonBaseCurrencyCd: string;
  public lastSalesGroupId: CubiqTS.Long;
  public lastClientBranchCd: string;
  public lastBaseCurrencyCd: string;
  public lastNonBaseCurrencyCd: string;
  public clientBranchHubCode: string;
  public clientBranchHubName: string;
  public fillUserCd: string;
  public fillUserName: string;
  public traderGroupName: string;
  public salesGroupNm: string;
  public traderGroupBranchCd: string;
  public isAggregateFillFg: boolean;
  public entryUserNm: string;
  public clientBookingCd: string;
  public accountBookingCd: string;
  public externalMarketRt: CubiqTS.BigNumber;
  public alternateClientCode: string;
  public hedgingRuleId: CubiqTS.Long;

  constructor() {
    super();
    this.encoder = OrderDataImplEncoder.Instance;
    this.setEncodableType(OrderDataImpl.enType);
  }

  public toString(): string {
    return (
      "OrderDataImpl[" +
      "isPrivate=" +
      this.isPrivate +
      "fixingDate=" +
      this.fixingDate +
      "rateSourceCd=" +
      this.rateSourceCd +
      "vwapAllInRt=" +
      this.vwapAllInRt +
      "swapDetails=" +
      this.swapDetails +
      "lastFillDetails=" +
      this.lastFillDetails +
      "siblingRelationship=" +
      this.siblingRelationship +
      "settleTenor=" +
      this.settleTenor +
      "adjustedSettleTenor=" +
      this.adjustedSettleTenor +
      "isInvertedOrderFg=" +
      this.isInvertedOrderFg +
      "orderErrors=" +
      this.orderErrors +
      "suspensionDetails=" +
      this.suspensionDetails +
      "expiryAlias=" +
      this.expiryAlias +
      "isOddFixingDateFg=" +
      this.isOddFixingDateFg +
      "trailingStopDetails=" +
      this.trailingStopDetails +
      "triggerDetails=" +
      this.triggerDetails +
      "leavesSettleQty=" +
      this.leavesSettleQty +
      "parentRelationship=" +
      this.parentRelationship +
      "usdEquivLeavesQty=" +
      this.usdEquivLeavesQty +
      "executedQty=" +
      this.executedQty +
      "executedSettleQty=" +
      this.executedSettleQty +
      "usdEquivExecutedQty=" +
      this.usdEquivExecutedQty +
      "creditRevalDetails=" +
      this.creditRevalDetails +
      "forwardDetails=" +
      this.forwardDetails +
      "strategyParameters=" +
      this.strategyParameters +
      "algoStrategyName=" +
      this.algoStrategyName +
      "targetDeskId=" +
      this.targetDeskId +
      "gammaRungId=" +
      this.gammaRungId +
      "clOrdLinkID=" +
      this.clOrdLinkID +
      "requestTrackingType=" +
      this.requestTrackingType +
      "fixingSourceCd=" +
      this.fixingSourceCd +
      "trackingSide=" +
      this.trackingSide +
      "monitoringOrderType=" +
      this.monitoringOrderType +
      "executionType=" +
      this.executionType +
      "requestedOrderType=" +
      this.requestedOrderType +
      "clientTraderName=" +
      this.clientTraderName +
      "activationAlias=" +
      this.activationAlias +
      "activationDts=" +
      this.activationDts +
      "childRelationships=" +
      this.childRelationships +
      "executionInstruction=" +
      this.executionInstruction +
      "isRateReverseEngineeringFg=" +
      this.isRateReverseEngineeringFg +
      "isAutoEligible=" +
      this.isAutoEligible +
      "nonBaseCode=" +
      this.nonBaseCode +
      "clientIntent=" +
      this.clientIntent +
      "orderId=" +
      this.orderId +
      "orderRef=" +
      this.orderRef +
      "orderRevisionId=" +
      this.orderRevisionId +
      "clientCode=" +
      this.clientCode +
      "clientName=" +
      this.clientName +
      "clientSegment=" +
      this.clientSegment +
      "clientIsTraderVisible=" +
      this.clientIsTraderVisible +
      "clientStraightThroughProcessing=" +
      this.clientStraightThroughProcessing +
      "orderType=" +
      this.orderType +
      "product=" +
      this.product +
      "comments1=" +
      this.comments1 +
      "orderQty=" +
      this.orderQty +
      "expiryDts=" +
      this.expiryDts +
      "trackingRt=" +
      this.trackingRt +
      "channelCd=" +
      this.channelCd +
      "isModifiable=" +
      this.isModifiable +
      "stpHold=" +
      this.stpHold +
      "clOrdID=" +
      this.clOrdID +
      "vwapSpotRt=" +
      this.vwapSpotRt +
      "comments2=" +
      this.comments2 +
      "expiryType=" +
      this.expiryType +
      "deskId=" +
      this.deskId +
      "slippage=" +
      this.slippage +
      "settleQty=" +
      this.settleQty +
      "leavesQty=" +
      this.leavesQty +
      "baseCode=" +
      this.baseCode +
      "fixedCode=" +
      this.fixedCode +
      "strategyId=" +
      this.strategyId +
      "strategyRef=" +
      this.strategyRef +
      "orderState=" +
      this.orderState +
      "requestRt=" +
      this.requestRt +
      "entryDts=" +
      this.entryDts +
      "fillState=" +
      this.fillState +
      "settleDate=" +
      this.settleDate +
      "txTime=" +
      this.txTime +
      "modifyDts=" +
      this.modifyDts +
      "clientBranchCode=" +
      this.clientBranchCode +
      "entryUserCode=" +
      this.entryUserCode +
      "accountCode=" +
      this.accountCode +
      "accountName=" +
      this.accountName +
      "reqMargin=" +
      this.reqMargin +
      "reqMarginType=" +
      this.reqMarginType +
      "salesMargin=" +
      this.salesMargin +
      "salesGroupId=" +
      this.salesGroupId +
      "transferUserId=" +
      this.transferUserId +
      "entryUserId=" +
      this.entryUserId +
      "lockUserId=" +
      this.lockUserId +
      "lockType=" +
      this.lockType +
      "usdEquivQty=" +
      this.usdEquivQty +
      "isAboutToActivate=" +
      this.isAboutToActivate +
      "isAboutToExpire=" +
      this.isAboutToExpire +
      "isAboutToSuspend=" +
      this.isAboutToSuspend +
      "isActivatingOrder=" +
      this.isActivatingOrder +
      "cancelUserId=" +
      this.cancelUserId +
      "cancelDts=" +
      this.cancelDts +
      "activationDetails=" +
      this.activationDetails +
      "expiryDetails=" +
      this.expiryDetails +
      "spotMarkupValue=" +
      this.spotMarkupValue +
      "spotMarkupType=" +
      this.spotMarkupType +
      "fwdMarkupValue=" +
      this.fwdMarkupValue +
      "fwdMarkupType=" +
      this.fwdMarkupType +
      "tradesCount=" +
      this.tradesCount +
      "clientTraderId=" +
      this.clientTraderId +
      "lastOwnerGroupId=" +
      this.lastOwnerGroupId +
      "siLockUserId=" +
      this.siLockUserId +
      "lastOwnerGroupIds=" +
      this.lastOwnerGroupIds +
      "ownerGroupIds=" +
      this.ownerGroupIds +
      "currencyPairIds=" +
      this.currencyPairIds +
      "messageId=" +
      this.messageId +
      "pauseState=" +
      this.pauseState +
      "allocationData=" +
      this.allocationData +
      "fixingDetails=" +
      this.fixingDetails +
      "filledBaseAmt=" +
      this.filledBaseAmt +
      "currencyPairAndOwners=" +
      this.currencyPairAndOwners +
      "algoProfileId=" +
      this.algoProfileId +
      "passthroughParameters=" +
      this.passthroughParameters +
      "stpAggregationEnabled=" +
      this.stpAggregationEnabled +
      "alternateAccountCode=" +
      this.alternateAccountCode +
      "modifyInAcceptanceFg=" +
      this.modifyInAcceptanceFg +
      "inflightInclusionState=" +
      this.inflightInclusionState +
      "oboClient=" +
      this.oboClient +
      "oboAccount=" +
      this.oboAccount +
      "creditRejectCd=" +
      this.creditRejectCd +
      "oboEntryUser=" +
      this.oboEntryUser +
      "oboLockUser=" +
      this.oboLockUser +
      "oboCancelUser=" +
      this.oboCancelUser +
      "modifyUsers=" +
      this.modifyUsers +
      "insidePrevisibilityFg=" +
      this.insidePrevisibilityFg +
      "inboxReason=" +
      this.inboxReason +
      "inboxOpsId=" +
      this.inboxOpsId +
      "nettingId=" +
      this.nettingId +
      "fwdNnettingId=" +
      this.fwdNettingId +
      "autoForwardPricingFg=" +
      this.autoForwardPricingFg +
      "hedgingMode=" +
      this.hedgingMode +
      "reqQuoteId=" +
      this.reqQuoteId +
      "fillNowOrderAmt=" +
      this.fillNowOrderAmt +
      "marketVwapSpotRt=" +
      this.marketVwapSpotRt +
      "marketVwapAllInRt=" +
      this.marketVwapAllInRt +
      "previousFixingDts=" +
      this.previousFixingDts +
      "previousTraderVisibilityOffset=" +
      this.previousTraderVisibilityOffset +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}

  public copyFrom(source: OrderData): void {
    if (source != null) {
      Object.keys(source).forEach((key) => (this[key] = source[key]));
    }
  }
}
